"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMPUTATION_SCALE = exports.CLIENT_MODULE = exports.DEFAULT_DATE_FILTER = exports.LANGUAGE = exports.INVOICED_BY = exports.CLIENT_CATEGORY = void 0;
var CLIENT_CATEGORY;
(function (CLIENT_CATEGORY) {
    CLIENT_CATEGORY["MARKET_RESEARCH"] = "MARKET_RESEARCH";
    CLIENT_CATEGORY["SAAS"] = "SAAS";
    CLIENT_CATEGORY["SAAS_PROJECT"] = "SAAS_PROJECT";
    CLIENT_CATEGORY["INTERNAL"] = "INTERNAL";
})(CLIENT_CATEGORY = exports.CLIENT_CATEGORY || (exports.CLIENT_CATEGORY = {}));
var INVOICED_BY;
(function (INVOICED_BY) {
    INVOICED_BY["OPTIMETRIKS"] = "OPTIMETRIKS";
    INVOICED_BY["OM_SERVICES_KENYA"] = "OM_SERVICES_KENYA";
})(INVOICED_BY = exports.INVOICED_BY || (exports.INVOICED_BY = {}));
var LANGUAGE;
(function (LANGUAGE) {
    LANGUAGE["EN"] = "EN";
    LANGUAGE["FR"] = "FR";
})(LANGUAGE = exports.LANGUAGE || (exports.LANGUAGE = {}));
var DEFAULT_DATE_FILTER;
(function (DEFAULT_DATE_FILTER) {
    DEFAULT_DATE_FILTER["TODAY"] = "TODAY";
    DEFAULT_DATE_FILTER["YESTERDAY"] = "YESTERDAY";
    DEFAULT_DATE_FILTER["LAST_7_DAYS"] = "LAST_7_DAYS";
    DEFAULT_DATE_FILTER["LAST_30_DAYS"] = "LAST_30_DAYS";
    DEFAULT_DATE_FILTER["THIS_WEEK"] = "THIS_WEEK";
    DEFAULT_DATE_FILTER["THIS_FULL_WEEK"] = "THIS_FULL_WEEK";
    DEFAULT_DATE_FILTER["LAST_WEEK"] = "LAST_WEEK";
    DEFAULT_DATE_FILTER["THIS_MONTH"] = "THIS_MONTH";
    DEFAULT_DATE_FILTER["LAST_MONTH"] = "LAST_MONTH";
})(DEFAULT_DATE_FILTER = exports.DEFAULT_DATE_FILTER || (exports.DEFAULT_DATE_FILTER = {}));
var CLIENT_MODULE;
(function (CLIENT_MODULE) {
    CLIENT_MODULE["GPS_TRACKER"] = "GPS_TRACKER";
    CLIENT_MODULE["GEO_CHECK_IN"] = "GEO_CHECK_IN";
    CLIENT_MODULE["CHAT_SUPPORT"] = "CHAT_SUPPORT";
})(CLIENT_MODULE = exports.CLIENT_MODULE || (exports.CLIENT_MODULE = {}));
var COMPUTATION_SCALE;
(function (COMPUTATION_SCALE) {
    COMPUTATION_SCALE["LINEAR"] = "LINEAR";
    COMPUTATION_SCALE["LOGARITHMIC"] = "LOGARITHMIC";
})(COMPUTATION_SCALE = exports.COMPUTATION_SCALE || (exports.COMPUTATION_SCALE = {}));
